import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { CommonService } from "./Services/common.service";
import { ConfigService } from "./Services/config.service";
import { AuthService } from "./Services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe, formatDate } from "@angular/common";
import * as parentconfig from "src/assets/i18n/en.json";
import { MapsAPILoader } from "@agm/core";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "Dubai Islamic Bank";
  referralCode: string = this.config.ReferralCode;
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;

  constructor(
    private httpClient: HttpClient,
    private mapsAPILoader: MapsAPILoader,
    private translate: TranslateService,
    public commonP: CommonService,
    private config: ConfigService,
    private auth: AuthService,
    private datepipe: DatePipe,
    private _router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    translate.setDefaultLang("en");
    translate.use("en");

    this.commonP.GetLatLong().then((data: any) => {
      if (data == "error") {
        this.translate.get(["Sorry", "LatLangMsg", "Ok"]).subscribe((data1) => {
          this.commonP.showErrorAlert(
            data1["Sorry"],
            data1["LatLangMsg"],
            data1["Ok"],
            this._router
          );
        });
      }
    });
    // console.log = function () { }
  }
  //V13 initial Push
  geoCoder;
  async ngOnInit() {

    this.commonP.Set("Referby", undefined);
    //load Places Autocomplete
    // console.log = function () { };
    await this.getversion();
  }

  showLoaderSubject: Subject<boolean> = this.commonP.showLoaderSubject;
  async getversion() {
    this.commonP.presentLoading();
    await this.auth.GetVersion().then((res: any) => {
      if (res?.response?.code == 1) {
        let checkVersionData: any = JSON.parse(
          this.commonP.DecryptCustome(res.response.content)
        );
        console.log(checkVersionData, "checkVersionData");
        this.config.TimeOut = checkVersionData.dynamicObject.TimeOut;
        this.config.ServerVersion = checkVersionData.version;
        this.config.BlinkIDAndroid =
          checkVersionData.dynamicObject.BlinkIDAndroid;
        this.config.BlinkIDIOS = checkVersionData.dynamicObject.BlinkIDIOS;
        this.config.OtpResendTime =
          checkVersionData.dynamicObject.OtpResendTime;
        this.config.Morning = checkVersionData.dynamicObject.Morning;
        this.config.Evening = checkVersionData.dynamicObject.Evening;
        this.config.Afternoon = checkVersionData.dynamicObject.Afternoon;
        this.config.videoSecret = checkVersionData.dynamicObject.VideoSecret;
        this.config.vidoeKey = checkVersionData.dynamicObject.VideoKey;
        this.config.AllowedTypeArray =
          checkVersionData.dynamicObject.AllowedTypeDoc;
        this.config.oecdsite = checkVersionData.dynamicObject.oecdsite;
        this.config.ReferralCode = checkVersionData.dynamicObject.ReferralCode;
        this.referralCode = checkVersionData.dynamicObject.ReferralCode;
        this.config.RefCodeExpiry =
          checkVersionData.dynamicObject.RefCodeExpiry;
        this.config.BlinkIDWeb = checkVersionData.dynamicObject.blinkIDweb;
        this.config.Deploytest = checkVersionData.dynamicObject.Deploytest;
        this.config.SMSAnnuallyLink =
          checkVersionData.dynamicObject.SMSAnnuallyLink;
        this.config.SMSMonthlyLink =
          checkVersionData.dynamicObject.SMSMonthlyLink;
        this.config.StatementDeclaration =
          checkVersionData.dynamicObject.StatementDeclaration;
        this.config.StatementUnderTaking =
          checkVersionData.dynamicObject.StatementUnderTaking;
        this.config.videotimeout = checkVersionData.dynamicObject.Videotimeout
          ? Number(checkVersionData.dynamicObject.Videotimeout)
          : 60;
        this.config.BlinkTimeOut = checkVersionData.dynamicObject.BlinkTimeOut;
        this.config.VidyoHost = checkVersionData.dynamicObject.VidyoHost
          ? checkVersionData.dynamicObject.VidyoHost
          : "managedservices.platform.vidyo.io";
        this.config.Switchrecaptcha =
          checkVersionData.dynamicObject.Switchrecaptcha;
        this.commonP.Set("BlinkIDWeb", this.config.BlinkIDWeb);
        this.commonP.Set("Deploytest", this.config.Deploytest);
      } else {
        if (res?.name == "TimeoutError") {
          this.translate
            .get(["Wewillbe", "WeRegrettheinconvenience", "Retry"])
            .subscribe((data) => {
              this.commonP
                .showErrorAlert(
                  data.Wewillbe,
                  data.WeRegrettheinconvenience,
                  data.Retry,
                  this._router
                )
                .then((data: any) => {
                  window.location.reload();
                });
            });
          this.commonP.hideLoading();
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, res);
        }
      }
    });
  }

  /* getIpAddress() {
     this.httpClient
       .get('http://ip-api.com/json')
       .subscribe((res: any) => {
         console.log(res)
         if (res.country == "Iran" || res.country == "North Korea" || res.country == "Cuba" || res.country == "Syria" || res.country == "Crimea" || res.country == "Israel") {
           this.commonP.countryBlock();
         } else {
           this.getversion();
         }
       })
   }*/




  private setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }
  addressObj;
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        console.log(results);
        console.log(status);
        var components;

        components = {};

        for (var i = 0; i < results[0].address_components.length; i++) {
          let ac = results[0].address_components[i];
          components[ac.types[0]] = ac.long_name;
        }

        this.addressObj = {
          street: components.street_number
            ? components.street_number
            : "not found",
          area: components.route,
          city: components.sublocality_level_1
            ? components.sublocality_level_1
            : components.locality,
          country: components.country
            ? components.country
            : components.political,
          postCode: components.postal_code,
          address: this.address,
        };
        console.log(this.addressObj, "jcb");

        if (status === "OK") {
          if (
            this.addressObj.country == "Iran" ||
            this.addressObj.country == "North Korea" ||
            this.addressObj.country == "Cuba" ||
            this.addressObj.country == "Syria" ||
            this.addressObj.country == "Crimea" ||
            this.addressObj.country == "Israel"
          ) {
            this.commonP.countryBlock();
          } else {
            this.getversion();
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
}
